import React from 'react'
import RecordDisplay, { ShowHide } from '../../../../ui/record-display'

const EntitlementForEnrolment = ({ entitlement = {} }) => {
  if (!entitlement) {
    return null
  }

  entitlement.annual_cap_reached = entitlement.ccs_annual_cap_reached ? 'Yes' : 'No'

  const displayFields = [
    {
      key: 'ccs_percentage',
      label: 'CCS %',
    },
    {
      key: 'withholding_percentage',
      label: 'CCS withholding %',
    },
    {
      key: 'accs_hourly_rate_cap_increase_percentage',
      label: 'ACCS %',
    },
    {
      key: 'ccs_hours_fortnight',
      label: 'Hours per fortnight',
    },
    {
      key: 'absence_count',
      label: 'Absence Count',
    },
    {
      key: 'annual_cap_reached',
      label: 'Annual Cap Reached',
    },
    {
      key: 'preschool_exemption',
      label: 'Preschool Exemption',
    },
    {
      key: 'paid_absences',
      label: 'Paid Absences',
    },
    {
      key: 'unpaid_absences',
      label: 'Unpaid Absences',
    },
    {
      key: 'absences_available_no_evidence',
      label: 'No-Evidence Absences Available',
    },
  ]

  return (
    <ShowHide label="entitlements">
      <RecordDisplay
        {...{
          record: entitlement,
          level1: displayFields,
          showRaw: true,
        }}
      />
    </ShowHide>
  )
}

export { EntitlementForEnrolment }



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/ccs-enrolment-entitlement/index.js